import { useNavigate } from 'react-router-dom';
import { getBuildingUrl } from 'services/navigation';
import type { Building } from 'services/api';
import type { AppTableProps } from 'shared/UI/UIKit/Table';

export const useBuildingsTable = () => {
  const navigate = useNavigate();

  const onRow: AppTableProps<Building>['onRow'] = (data) => {
    return {
      onClick: () => {
        navigate(
          getBuildingUrl({
            buildingId: data.id!.toString(),
          }),
        );
      },
    };
  };

  return {
    onRow,
  };
};
